import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ReplyArrowRegularAi from './reply-arrow-regular-ai-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ReplyArrowRegularAi {...validProps} />;
}
SvgComponent.iconName = 'replyArrowRegularAi';

export const ReplyArrowRegularAiIcon = svgIconWrapper(SvgComponent);
